import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-blue-600">404</h1>
        <p className="text-white text-2xl font-semibold mt-4">Page introuvable</p>
        <p className="text-gray-400 mt-2">La page que vous cherchez n'existe pas.</p>
        <Link
          to="/"
          className="mt-6 inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition duration-200"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFound;